export const GYM_SOFTWARE_COMPETITORS = [
  "ABC",
  "Arbox",
  "Atlas",
  "Big Little Gym - (BLG)",
  "Bushido",
  "Chalk It Up Pro",
  "DojoExpert",
  "GloFox",
  "Gym Lead Machine - (GLM)",
  "Gym Master",
  "GymDesk",
  "Kilo",
  "Kicksite",
  "Market Muscles",
  "Martialytics",
  "Member Solutions",
  "Mindbody - (MBO)",
  "Momence",
  "MyStudio",
  "None",
  "Pen and paper",
  "Pike 13",
  // Current users are coming into SAF in order to find help from someone
  // Adding this temporarily in order to help sales team route users to CX
  // TODO: Remove PushPress - https://linear.app/pushpress/issue/GRWTH-436/remove-pushpress-from-current-software-list
  "PushPress",
  "Rainmaker",
  "RealBookies",
  "RhinoFit",
  "Spark",
  "StreamFit",
  "TeamBuildr",
  "TrainHeroic",
  "Trainerize",
  "Triib - (Xplor)",
  "TrueCoach",
  "UpLaunch",
  "VirtuaGYM",
  "Wellness Living",
  "Wodify",
  "Zenplanner",
] as const;

export type GymSoftwareCompetitor = (typeof GYM_SOFTWARE_COMPETITORS)[number];
